import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const uploadBot = async (file) => {
  try {
    let formData = new FormData();
    formData.append('bot-file', file);
    let { status } = await axios.post(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot`, formData);
    if (status === 201) {
      addNotification({
        title: "Techforce.ai",
        message: " Action Flow has been published successfully",
        type: "success"
      });
    }
  } catch (err) {
    addNotification({
      title: "Techforce.ai",
      message: "Publishing Action Flow Failed",
      type: "danger"
    });
  }
};
